import React, { Component } from "react";

export default class Avatar extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="avatar">
       
        <div className="avatar-img">
          <img src={this.props.image} />
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/chatList/Avatar.js